<template>
  <el-dialog title="生产订单关键器件" :visible.sync="visible" width="500px" @close="close">
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="主条码" prop="barcode">
        <el-input v-model="form.barcode" placeholder="请输入主条码"/>
      </el-form-item>
      <el-form-item label="工单号" prop="productionOrderNo">
        <el-input v-model="form.productionOrderNo" placeholder="请输入工单号"/>
      </el-form-item>
      <el-form-item label="物料号" prop="materialNo">
        <el-input v-model="form.materialNo" placeholder="请输入物料号"/>
      </el-form-item>
      <el-form-item label="部件物料号" prop="componentMaterialNo">
        <el-input v-model="form.componentMaterialNo" placeholder="请输入部件物料号"/>
      </el-form-item>
      <el-form-item label="部件条码" prop="componentBarcode">
        <el-input v-model="form.componentBarcode" placeholder="请输入部件条码"/>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "ComponentBindingEdit",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        barcode: '',
        productionOrderNo: '',
        materialNo: '',
        componentMaterialNo: '',
        componentBarcode: ''
      }
    };
  },
  watch: {
    data: {
      handler(newVal) {
        this.form = Object.assign({}, newVal);
      },
      immediate: true
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
      this.$refs.form.resetFields();
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('submit', this.form);
        }
      });
    }
  }
};
</script>